/**@jsx jsx */
import { jsx, Flex, Button } from 'theme-ui'
import { useRef } from 'react'

const Role = ({ role }) => {
  const { role_title, role_location, role_type, role_url, salary_start, salary_end } = role
  console.log('sal', salary_start, salary_end)
  return (
    <Flex
      sx={{
        border: '1px solid lightgrey',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '2px',
        padding: '1rem',
        minWidth: '275px',
        maxWidth: '275px',
        marginLeft: '5px',
        marginRight: '5px',
        textAlign: 'center',
        '&:first-of-type': {
          marginLeft: 0,
        },
        '&:last-child': {
          marginRight: 0,
        },
      }}
    >
      <h4>{role_title}</h4>
      <p>{role_location}</p>
      <p>{role_type}</p>
      {!salary_start || !salary_end ? null : <p>{`${salary_start} - ${salary_end}`}</p>}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={role_url}
        sx={{
          color: 'white',
          width: '66px',
          border: '1px',
          borderRadius: '2px',
          padding: '3px',
          marginTop: '5px',
          backgroundColor: 'primary',
          textAlign: 'center',
          transition: 'all .5s',
          backgroundImage: 'linear-gradient(90deg,#705ecf 0%,#E50A68 100%)',
          '-webkit-text-fill-color': 'white',
          '&:hover': {
            color: 'white',
            boxShadow: '-2px 2px 0 0 rgba(0, 0, 0, .5)',
            backgroundColor: 'purple',
          },
        }}
      >
        Apply
      </a>
    </Flex>
  )
}

const Roles = ({ roles }) => {
  const scrollPos = useRef()

  const scroll = (direction) => {
    if (direction === 'left') {
      scrollPos.current.scrollLeft -= 300
    } else {
      scrollPos.current.scrollLeft += 300
    }
  }

  if (roles === 0) {
    return <h3>No roles at this moment.</h3>
  } else {
    return (
      <Flex sx={{ width: '100%', maxWidth: '1100px', marginTop: '20px' }}>
        {roles.length > 1 && (
          <Button
            sx={{
              height: '40px',
              alignSelf: 'center',
              backgroundImage: 'linear-gradient(90deg,#705ecf 0%,#E50A68 100%)',
              '-webkit-text-fill-color': 'white',
            }}
            alt="Scroll Left"
            onClick={() => scroll('left')}
          >
            {'<'}
          </Button>
        )}

        <Flex
          ref={scrollPos}
          sx={{
            overflowX: 'scroll',
            scrollBehavior: 'smooth',
            width: '100%',
            paddingLeft: [0, '3px'],
            paddingRight: '20px',
            justifyContent: roles.length < 1 ? 'flex-start' : null,
          }}
        >
          {roles.map((role, i) => (
            <Role key={i} role={role} />
          ))}
        </Flex>
        {roles.length > 1 && (
          <Button
            sx={{
              height: '40px',
              alignSelf: 'center',
              backgroundImage: 'linear-gradient(90deg,#705ecf 0%,#E50A68 100%)',
              '-webkit-text-fill-color': 'white',
            }}
            alt="Scroll Right"
            onClick={() => scroll('right')}
          >
            {'>'}
          </Button>
        )}
      </Flex>
    )
  }
}

export default Roles
